import axios from "axios";
import API from "../helpers/api";
import {
  getShipStatusList
} from "../Actions/ShipManagementAPI"
import { getServiceTypeList } from "../Actions/CommonAPI";

export const getMMPLShipCount = (contract, both, isincontract) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.MMPLShipCount}?mail=${user.email}&inContract=${contract}&isBoth=${both}&isInContract=${isincontract}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipCountSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipCountFailure",
          error: "ERROR",
        });
      });
  };
};
export const exportToExcel = (searchItem) => {
  /*  let user = JSON.parse(localStorage.getItem("currentUser"));
   let Role = user.role;
   let value = false;
   if (Role === "client") {
     value = true;
   } else {
     value = false;
   }
 
   return (dispatch) => {
     axios
       .get(url)
       .then((response) => {
         console.log(response.status);
         
         dispatch({
           type: "GetExportToExcelSuccess",
           data: response.data,
         });
       })
       .catch((error) => {
         dispatch({
           type: "GetExportToExcelFailure",
           error: "ERROR",
         });
       }); 
   };*/
};

export const getShipSearchlist = (searchItem, contract, both, totalships) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.getShipSearch}?FliterByTotalShips=${totalships ? true : false}&FilterByIsInContract=${searchItem.FilterByIsInContract == true ? true : searchItem.FilterByIsInContract == false && searchItem.FilterByIsInContract !== '' ? false : ''}&status=${searchItem.status}&FliterByOverDue=${searchItem.isOverdueShips}&FliterByDueIn30Days=${searchItem.isShipsDue30}&FliterByDueIn90Days=${searchItem.isShipsDue90}&MMPLFliterByDueIn10Days=${searchItem.isShipsDue10}&MMPLFliterByDueIn60Days=${searchItem.isShipsDue60}&IsClient=${searchItem.IsClient}&ShipName=${searchItem.shipName}&imo=${searchItem.imoNo}&MmplClientName=${searchItem.client}&MmplCategoryName=${searchItem.category}&ServiceTypes=${searchItem.ServiceTypes}&NextDueInFromDate=${searchItem.nextServiceDateFrom}&NextDueInToDate=${searchItem.nextServiceDateTo}&noOfRecords=${searchItem.noofrecords}&PageNumber=${searchItem.pagenumber}&PageSize=${searchItem.pagesize}&Mail=${user.email}&inContract=${contract}&isBoth=${both}&isShipService=${searchItem?.isShipSearch != undefined ? searchItem?.isShipSearch : false}&isShoreService=${searchItem?.isShoreSearch != undefined ? searchItem?.isShoreSearch : false}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "GetMMPLSearchSuccess",
            data: response.data,
          });
          /* dispatch(getMMPLShipCount(contract,both));
          dispatch(getServiceTypeList());
          dispatch(getShipStatusList()) */
        }

      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLSearchFailure",
          error: "ERROR",
        });
      });
  };
};
export const getpendingShipSearchlist = (searchItem, contract, both) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.getShipSearch}?FliterByTotalShips=${searchItem.isTotalShips}&status=${searchItem.status}&FliterByOverDue=${searchItem.isOverdueShips}&FliterByDueIn30Days=${searchItem.isShipsDue30}&FliterByDueIn90Days=${searchItem.isShipsDue90}&MMPLFliterByDueIn10Days=${searchItem.isShipsDue10}&MMPLFliterByDueIn60Days=${searchItem.isShipsDue60}&IsClient=${searchItem.IsClient}&ShipName=${searchItem.shipName}&imo=${searchItem.imoNo}&MmplClientName=${searchItem.client}&MmplCategoryName=${searchItem.category}&ServiceTypes=${searchItem.ServiceTypes}&NextDueInFromDate=${searchItem.nextServiceDateFrom}&NextDueInToDate=${searchItem.nextServiceDateTo}&noOfRecords=${searchItem.noofrecords}&PageNumber=${searchItem.pagenumber}&PageSize=${searchItem.pagesize}&Mail=${user.email}&inContract=${contract}&isBoth=${both}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: "GetMMPLPendingSearchSuccess",
            data: response.data,
          });
          dispatch(getMMPLShipCount(contract, both, ''));
          dispatch(getServiceTypeList());
          dispatch(getShipStatusList())
        }
        dispatch({ type: "searchData", data: "" });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLPendingSearchFailure",
          error: "ERROR",
        });
      });
  };
};

export const getHistorySearchlist = (searchhistoryItem) => {
  let user = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.getHistorySearch}?ActionBy=${searchhistoryItem.actionBy}&ModuleName=${searchhistoryItem.moduleName}&Mail=${user.email}&From=${searchhistoryItem.nextDateFrom}&To=${searchhistoryItem.nextDateTo}&PageNumber=${searchhistoryItem.pagenumber}&PageSize=${searchhistoryItem.pagesize}&SortBy=actionedDate&SortOrder=asc`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLHistorySearchSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLHistorySearchFailure",
          error: "ERROR",
        });
      });
  };
};


export const getMMPLShipDeatil = (shipId) => {
  let url = `${API.MMPLShipDetail + shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

// export const getMMPLSearchlist = (searchItem) => {
//     var searchResult = [
//         {
//             "clientId": 1,
//             "shipId": 1,
//             "equipmentId": 1,
//             "ShipEquipmentId": 1,
//             "equipmentServiceId": 1,
//             "AttachmentId": 1,
//             "shipName": "Qantler",
//             "AttachmentName": "aaa.pdf",
//             "AttachmentGuid": "maddfadweaad23qedwad1d",
//             "totalEquipment": 100,
//             "overDue": 50,
//             "dueIn30Days ": 50,
//             "dueIn90Days ": 50,
//             "createdBy": "gg",
//             "createdDate": "2000-01-01",
//             "modifiedBy": "gg",
//             "modifiedDate": "2000-01-01"
//         },
//         {
//             "clientId": 2,
//             "shipId": 3,
//             "equipmentId": 1,
//             "ShipEquipmentId": 1,
//             "equipmentServiceId": 1,
//             "AttachmentId": 1,
//             "shipName": "Qantler",
//             "AttachmentName": "aaa.pdf",
//             "AttachmentGuid": "maddfadweaad23qedwad1d",
//             "totalEquipment": 100,
//             "overDue": 50,
//             "dueIn30Days ": 50,
//             "dueIn90Days ": 50,
//             "createdBy": "gg",
//             "createdDate": "2000-01-01",
//             "modifiedBy": "gg",
//             "modifiedDate": "2000-01-01"
//         }
//     ];
//     return dispatch => {
//         dispatch({
//             type: "GetMMPLSearchSuccess",
//             data: searchResult
//         })
//     }

// }

export const getMMPLShipInfo = (info) => {
  // var info = {
  //     "ShipId": 1,
  //     "equipmentId": 1,
  //     "equipmentName": "qwe",
  //     "equipmentType": "CO2",
  //     "capacity": "1kg",
  //     "make": "hd",
  //     "model": "mg1",
  //     "manufacturingDate": "2000-01-01",
  //     "quantity": "1",
  //     "category": "xxx",
  //     "additionalInformation": " Additional Information for equipment",
  //     "serviceType": "annually",
  //     "lastDone": "2000-01-01",
  //     "lastServicePort": "India",
  //     "nextDue": "2000-01-01",
  //     "createdBy": "gg",
  //     "createdDate": "2000-01-01",
  //     "modifiedBy": "gg",
  //     "modifiedDate": "2000-01-01"
  // };
  // return dispatch => {
  //     dispatch({
  //         type: "GetMMPLShipInfoSuccess",
  //         data: info
  //     })
  // }

  let url = `${API.GetShipInfo}?shipId=${info.shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipInfoSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipInfoFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLShipDetails = (shipId) => {
  let url = `${API.GetMMPLShipDetails + shipId}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "GetMMPLShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GetMMPLShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getMMPLShipHistory = (shipId) => {
  var historyDetail = [
    {
      shipId: 1,
      shipEquipmentId: 1,
      equipmentServiceId: 1,
      serviceType: "annually",
      serviceDate: "2000-01-01",
      port: "India",
      remarks: "xxx",
      attachmentName: "aaa.pdf",
      attachmentGuid: "adfadadad",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
    {
      shipId: 2,
      shipEquipmentId: 2,
      equipmentServiceId: 1,
      serviceType: "annually",
      serviceDate: "2000-01-01",
      port: "India",
      remarks: "xxx",
      attachmentName: "aaa.pdf",
      attachmentGuid: "adfadadad",
      createdBy: "SNR",
      creatdeDate: "2000-01-01",
      modifiedBy: "SNR",
      modifiedDate: "2000-01-01",
    },
  ];
  return (dispatch) => {
    dispatch({
      type: "GetMMPLShipHistorySuccess",
      data: historyDetail,
    });
  };

  // let url = `${API.GetMMPLShipHistory + shipId}`;
  // return dispatch => {
  //     axios.get(url)
  //         .then((response) => {
  //             dispatch({
  //                 type: "GetMMPLShipHistorySuccess",
  //                 data: response.data
  //             })
  //         })
  //         .catch((error) => {
  //             dispatch({
  //                 type: "GetMMPLShipHistoryFailure",
  //                 error: "ERROR"
  //             })
  //         })
  //     }
};
